import React from "react";
import { reduce } from "et3-type-guards";
import { useLocation } from "react-router-dom";
import i18n from "../../constants/i18n";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import Et3PageTitle from "../../core/et3-page-title/index";
import getCoreHistoryStore from "../../stores/core/core-history-store";
import getReportsStore from "../../stores/reports-store";
import ReportsForm from "./reports-form";
import ReportsData from "./reports-data";
import Et3Margin from "../../core/et3-ui/ET3Margin";
import ET3PageDiv from "../../core/et3-page-div";

const Reports = withLiteObserverAndTheme(() => {
  const location = useLocation();

  React.useEffect(() => {
    const search = reduce(() => location.search, "");
    getCoreHistoryStore().setPageName("REPORTS", "REPORTS");
    getReportsStore().checkURLSearch(search);
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      justifyContent="center"
      alignItems="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("REPORTS")}
        subTitle={i18n.get("REPORTS_USER_TO_USER")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <ReportsForm />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <ReportsData />
    </ET3PageDiv>
  );
});
export default Reports;
